import type { App } from "vue";
import orbynDesignSystem from "@orbyn/design-system-core";

export default (app: App) => {
  //@ts-expect-error It is necessary to see why in this system with astro it gives error and not directly in vue
  app.use(orbynDesignSystem);
};
